export const ROUTING_CONFIG = {
  stairsCostMultiplier: 1.0, // 階段のコスト倍率
  elevatorCostMultiplier: 1.0, // エレベーターのコスト倍率
  floorChangeCost: 10000, // フロア変更の基本コスト
  turnChangeCost: 20,
  linkDataPath: "/linkData.json",
};
